// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"az_XNc"};